const faqs = [
  {
    question: "Does Utah have its own regional passport agency?",
    answer: "No — Utah does not have a regional passport agency. The nearest agencies are the Denver Passport Agency (approximately 7 hours from Salt Lake City) and the Los Angeles Passport Agency (approximately 11 hours). Using a registered courier like Fast Passport Center is dramatically faster and more convenient for most Utah residents.",
  },
  {
    question: "How fast can I get a passport in Utah?",
    answer: "With Fast Passport Center's courier service, Utah travelers can receive a passport in as little as 24 hours. Our standard expedited service ranges from 3 to 9 business days. Routine processing through the post office typically takes 6 to 13 weeks.",
  },
  {
    question: "Do I need to visit a passport acceptance facility in Utah?",
    answer: "First-time applicants, minors, and those replacing lost or stolen passports must visit an acceptance facility — typically a post office, county clerk, or public library. Renewals for adults can usually be done by mail without an in-person visit.",
  },
  {
    question: "How do LDS missionaries get their passports quickly for their mission?",
    answer: "Missionaries departing on LDS missions need a standard civilian passport. Given that mission calls often come with tight departure timelines, using an expedited courier service like Fast Passport Center is strongly recommended. We can process passports in as little as 24 hours to ensure missionaries are ready on time.",
  },
  {
    question: "Which airport should I fly from for international travel from Utah?",
    answer: "Salt Lake City International Airport (SLC) is the primary gateway and is a major Delta hub with direct non-stop flights to Mexico, Canada, and Europe. The recently renovated terminal has expanded international options significantly. St. George (SGU) and Provo (PVU) are smaller alternatives for intrastate connections.",
  },
  {
    question: "Can I get a passport quickly for a last-minute ski trip or international adventure from Utah?",
    answer: "Yes — Fast Passport Center can process passports in as little as 24 hours for emergency cases, or 3–9 business days for standard expedited processing. Utah's outdoor adventure culture — from skiing to international trekking and cycling — means last-minute international trip planning is common. Start your application the moment you know you need a passport.",
  },
];

export { faqs };

export default function UTFAQSection() {
  return (
    <section id="faq" className="bg-[#F7F8FA] py-20 md:py-28">
      <div className="max-w-3xl mx-auto px-4 md:px-8">
        <div className="text-center mb-14">
          <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-3">FAQ</p>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1A365D] mb-4">
            Utah Passport Questions
          </h2>
          <p className="text-gray-500 text-base leading-relaxed">
            Quick answers for travelers applying for passports across the state of Utah.
          </p>
        </div>

        <div className="space-y-4">
          {faqs.map((faq, i) => (
            <details key={i} className="group bg-white rounded-lg border border-gray-200 overflow-hidden">
              <summary className="flex items-center justify-between cursor-pointer p-5 list-none">
                <span className="font-bold text-[#1A365D] text-sm pr-4">{faq.question}</span>
                <div className="w-7 h-7 flex items-center justify-center rounded-full bg-[#EEF2F8] flex-shrink-0">
                  <i className="ri-add-line text-[#1A365D] text-sm group-open:ri-subtract-line"></i>
                </div>
              </summary>
              <div className="px-5 pb-5">
                <p className="text-gray-500 text-sm leading-relaxed">{faq.answer}</p>
              </div>
            </details>
          ))}
        </div>
      </div>
    </section>
  );
}